import { Outlet, Link } from "react-router-dom";
import { AdminPageShell } from "@/components/admin/AdminPageShell";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { ConfigOwnerCallout } from "@/components/admin/ConfigOwnerCallout";
import {
  BRAND_MUX_CREATOR_ID,
  BRAND_MUX_EXTERNAL_ID_FEED,
  BRAND_SOURCE_KEY,
} from "@/lib/brandConfig";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PrivateReelsSubnav } from "./PrivateReelsSubnav";

/**
 * Layout for /admin/reels/* — subnav + shared chrome.
 * Heavy data loads only in leaf pages (perf).
 */
export default function PrivateReelsLayout() {
  return (
    <AdminPageShell width="lg">
      <AdminPageHeader
        title="Reels privados"
        description={`/reels · creator_id=${BRAND_MUX_CREATOR_ID} · external_id=${BRAND_MUX_EXTERNAL_ID_FEED} · ${BRAND_SOURCE_KEY}`}
        actions={
          <Button type="button" size="sm" variant="ghost" asChild>
            <a href="/reels" target="_blank" rel="noreferrer">
              <ExternalLink className="h-3.5 w-3.5 mr-1" /> Abrir /reels
            </a>
          </Button>
        }
      />
      <ConfigOwnerCallout
        variant="owner"
        owns="Upload Mux feed, acceso, links multi-uso y secret-share de /reels."
        notHere="Layout Reels del embudo invitacion-premium → no editar acá."
        ownerPath="/admin/premium-invite-config"
        ownerLabel="Invit. premium (otro pipeline)"
      />
      <p className="text-xs text-muted-foreground -mt-1">
        Reels del embudo{" "}
        <Link className="underline" to="/admin/premium-invite-config#layout-reels">
          invitacion-premium
        </Link>{" "}
        se gestionan aparte. Usá las subpáginas para no cargar todo de una vez.
      </p>
      <PrivateReelsSubnav />
      <div className="pt-2">
        <Outlet />
      </div>
    </AdminPageShell>
  );
}
